import { ContentSection } from "@/types";
import { RichText } from "@/components/StrapiComponents/RichText";

export const ContentSectionComponent = ({ content, evenOdd }: { content: ContentSection; evenOdd?: boolean }) => {
	return (
		<section className={`section-wrapper section-content ${content.dark ? "dark" : ""} ${content.dark ? (evenOdd ? "even" : "odd") : ""} orientation-${content.orientation}`}>
			<div className="max-wrapper-content">
				<RichText content={content.content} />
			</div>
		</section>
	);
};
